import * as React from "react";
// import { Link } from "react-router-dom";
import { Typography, Button, Paper, Grid } from "@material-ui/core";
import Search from "./Search";
import { readUserAgent, userAgent } from "../../functions/analyseUserAgent";
import './Home.css';

const ImageHome =
  "https://images.unsplash.com/photo-1470309864661-68328b2cd0a5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2550&q=80";

const ImageWoman =
  "https://images.unsplash.com/photo-1478146896981-b80fe463b330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2468&q=80";

const ImageMan =
  "https://images.unsplash.com/photo-1555683236-104f9922a513?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2468&q=80";

const styles = {
    paperContainer: {
        backgroundImage: `url(${ImageHome})`,
        backgroundPosition: 'center',
        size: 'absolute',
        minHeight: "400px",
       justifyContent: 'center',
       flex: 1,
       alignItems: 'center',
       
       lineheight: '50%'
    },
}

class Home extends React.Component<any> {
  public render() {
    // const MyLinkProduct = (props: any) => <Link to={process.env.PUBLIC_URL + "/products"} {...props} />;
    // const MyLinkWoman = (props: any) => <a href="/app-skeleton-demo-shop/woman" {...props}/>;
    const MyLinkProduct = (props: any) => <a href={process.env.PUBLIC_URL + "/products"} {...props}/>;
    const MyLinkWoman = (props: any) => <a href={process.env.PUBLIC_URL + "/woman"} {...props}/>;
    const MyLinkMan = (props: any) => <a href={process.env.PUBLIC_URL + "/man"} {...props}/>;
    readUserAgent();
    const search: any = userAgent.isApp === true ? null : <Search />;

    return (
      <div className="home-all">
        <div className="container">
          <Paper style={styles.paperContainer}>
            <Grid
              container={true}
              spacing={0}
              direction="column"
              alignItems="center"
              justify="center"
              style={{ minHeight: "100vh" }}
            >
              <Grid item={true} xs={8}>
                <Typography
                  className="typo"
                  align="inherit"
                  color="secondary"
                  variant="h2"
                >
                  Start Shopping Now
                </Typography>
                <div className="diff" />
                <Button
                  color="secondary"
                  size="large"
                  variant="contained"
                  className="Buttons"
                  component={MyLinkProduct}
                  onClick={e => { this.props.actionUpdate()}}
                >
                  See all products
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </div>
        {search}
        <div className="rowH">
          <div className="columnH">
            <img alt={"woman"} className="img-h" src={ImageWoman} />
            <div className="centered">
              <Button
                color="secondary"
                size="large"
                variant="contained"
                className="Buttons"
                component={MyLinkWoman}
                onClick={e => {this.props.actionUpdate()}}
              >
                Women
              </Button>
            </div>
          </div>
          <div className="columnH">
            <img alt={"man"} className="img-h" src={ImageMan} />
            <div className="centered">
              <Button
                color="secondary"
                size="large"
                variant="contained"
                className="Buttons"
                component={MyLinkMan}
                onClick={e => this.props.actionUpdate()}
              >
                Men
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Home;

// function urlChange() {
//   window.location.href += "woman";
//   location.reload();
// }


// WEBPACK FOOTER //
// ./src/components/home/Home.tsx